/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import DropZone from '/client/src/components/dropZone';
import CropZoneJCrop from '/client/src/components/jCrop';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

import './styles.scss';

type ImageType = {
  file: null | File,
  image: null | string | ArrayBuffer
};

type PropsType = {
  openedCropModal: boolean,
  baseImage: ImageType,
  croppedImage: ImageType,
  setOpenedCropModal: (boolean) => void,
  setBaseImage: (ImageType) => void,
  setCroppedImage: (ImageType) => void,
  id: string,
  handleSetImages: (any) => void,
  imgUrl?: string,
  i18n?: any,
  setImageCropInfo?: (any) => void,
  image_crop_info?: any,
  aspect?: number,
  imageSizeLimit?: number
};
type StateType = {};

class DropCropZone extends React.Component<PropsType, StateType> {
  state: StateType = {
    useDefaultCrop: false
  };

  static contextType = DefaultContainerContext;

  handleOpenCropModal = (): any => this.props.setOpenedCropModal(true);

  handleCloseCropModal = (): any => this.props.setOpenedCropModal(false);

  handleDrop = async (acceptedFiles: Array<File>, fileRejections: any) => {
    if (_.size(fileRejections)) {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: fileRejections[0].errors[0].code === 'file-too-large' ? 'File is too large.' : 'Image upload failed'
      });

      return;
    }

    this.props.setCroppedImage({ file: null, image: null });

    if (_.size(acceptedFiles) > 0) {
      const _image = await this.getFile(acceptedFiles[0]);

      this.props.setBaseImage({ file: acceptedFiles[0], image: _image });
      this.props.setCroppedImage({ file: acceptedFiles[0], image: _image });
      this.setState({
        useDefaultCrop: true
      }, () => {
        this.handleOpenCropModal();
      });
    }
  };

  handleCrop = (image_crop_info: any) => {
    this.props.setImageCropInfo(image_crop_info);
    this.setState({
      useDefaultCrop: false
    });
    this.handleCloseCropModal();
  }

  getFile = (file: File): Promise<void> => new Promise<string | ArrayBuffer>((resolve: () => void) => {
    const reader = new FileReader();

    reader.addEventListener('load', (): any => resolve(reader.result));

    reader.readAsDataURL(file);
  });

  render = (): React.Element<'div'> => (
    <div className="dropCropZone">
      <DropZone
        imageSource={this.props.imgUrl}
        image_crop_info={this.props.image_crop_info}
        onDrop={this.handleDrop}
        i18n={this.props.i18n}
        imageSizeLimit={this.props.imageSizeLimit}
        onlyImages
      />
      <CropZoneJCrop
        src={this.props.baseImage.image}
        crop={this.props.image_crop_info}
        openedCropModal={this.props.openedCropModal}
        onDone={this.handleCrop}
        onClose={this.handleCloseCropModal}
        useDefaultCrop={this.state.useDefaultCrop}
        aspect={this.props.aspect}
      />
    </div>
  );
}

export default DropCropZone;
